import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { TagValuesPage } from "~/pages/TagValuesPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/tags_/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug, id } = Route.useParams();
  useBreadCrumbs([
    { title: "Tags", link: `/${datasetSlug}/settings/tags` },
    { title: "Values", link: `/${datasetSlug}/settings/tags/${id}` },
  ]);
  return <TagValuesPage tagDefinitionId={id} />;
}
